// formatMessageTime — pure formatter for a chat message timestamp.
//
// Extracted verbatim from `AIChatBot.js` (the in-component `formatTime` helper)
// as part of the behavior-preserving refactor (issue #240). Formats a timestamp
// as a 12-hour "h:mm AM/PM" en-US time string. It is input-only (it formats the
// timestamp passed to it, not the wall-clock "now"), so no clock injection is
// required.
//
// React-free and side-effect-free. As in the source, `timestamp` is assumed to
// be a Date (every message carries a Date `timestamp`); the `.toLocaleTimeString`
// call is preserved verbatim without a defensive guard the source lacked.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Formats a message timestamp as a 12-hour en-US time string.
 *
 * @param {Date} timestamp - The message timestamp.
 * @returns {string} The formatted time, e.g. "3:05 PM".
 */
export function formatMessageTime(timestamp) {
  return timestamp.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

export default formatMessageTime;
